import * as React from 'react';
import { ListBox } from '../ListBox';
import { ListTreeLegend } from '../ListTreeLegend';

import { List, ListItem, TopItem } from './styles';

export const ListTree = props => {
	const getDataChunks = (data, chunkLength) => {
		return data.reduce((acc, item) => {
			if (acc.length === 0) {
				acc.push([]);
			}

			let currentChunk = acc[acc.length - 1];

			if (currentChunk.length === chunkLength) {
				acc.push([]);
			}

			currentChunk = acc[acc.length - 1];

			currentChunk.push(item);

			return acc;
		}, []);
	};

	const {
		data,
		total,
		splitItems,
		colors,
		exportId,
		renderContextualMenu,
	} = props;

	let colsPerRow = 3;

	if (splitItems && splitItems.length > 2) {
		colsPerRow = 2;
	}
	if (splitItems && splitItems.length >= 4) {
		colsPerRow = 1;
	}

	const chunks = getDataChunks(data, colsPerRow);

	return (
		<div id={exportId}>
			<TopItem colsPerRow={colsPerRow}>
				<ListBox
					colors={colors}
					total={total}
					isTopItem
					selectedCompanies={splitItems}
				/>
			</TopItem>
			{chunks.map((chunkOfData, j) => (
				<List
					singleItemList={chunkOfData.length === 1 || splitItems.length > 4}
					keepConnectorLine={chunks.length === 1}
					pairItemList={chunkOfData.length === 2}
					colsPerRow={colsPerRow}
					key={j}
				>
					{chunkOfData.map((dataItem, i) => (
						<ListItem key={i}>
							<ListBox
								colors={colors}
								colsPerRow={colsPerRow}
								total={{
									name: dataItem.name,
									value: dataItem.value,
								}}
								parentName={total.name}
								data={dataItem.data}
								selectedCompanies={splitItems}
								renderContextualMenu={renderContextualMenu}
							/>
						</ListItem>
					))}
				</List>
			))}
			{splitItems &&
				splitItems.length > 1 && (
					<ListTreeLegend data={splitItems} colors={colors} />
				)}
		</div>
	);
};
